import React, { useEffect } from "react";
import "./RockThrowAnimation.css";

export default function RockThrowAnimation({ playerRef, opponentRef, onComplete }) {
  useEffect(() => {
    const opponentEl = opponentRef.current;
    const container  = opponentEl.closest(".battle-container");
    if (!opponentEl || !container) return;

    // 1) Compute foe center & container bounds
    const oRect = opponentEl.getBoundingClientRect();
    const cRect = container.getBoundingClientRect();
    const endX  = (oRect.left + oRect.width / 2) - cRect.left;
    const endY  = (oRect.top  + oRect.height / 2) - cRect.top;

    // 2) Spawn rocks above the top, with random X scatter around foe
    const spawnY = -150;      // start well above the view
    const total  = 10;        // more = heavier rain
    const rocks  = [];

    for (let i = 0; i < total; i++) {
      const rock = document.createElement("div");
      rock.className = `rock-fall ${Math.random() < 0.5 ? "large" : "small"}`;

      // scatter ± half foe width
      const scatter = (Math.random() - 0.5) * oRect.width;
      const startX  = endX + scatter;

      rock.style.left           = `${startX}px`;
      rock.style.top            = `${spawnY}px`;
      rock.style.setProperty("--dx", `0px`);                     // vertical drop
      rock.style.setProperty("--dy", `${endY - spawnY}px`);     // distance to foe
      rock.style.setProperty("--angle", `${Math.random()*360}deg`);
      rock.style.animationDelay = `${i * 0.05}s`;                // stagger

      container.appendChild(rock);
      rocks.push(rock);
    }

    // 3) When the last rock lands, do impact & cleanup
    const last = rocks[rocks.length - 1];
    const handleImpact = () => {
      rocks.forEach(r => r.remove());

      // foe gets a shake + dark tint
      opponentEl.classList.add("rock-hit");
      setTimeout(() => opponentEl.classList.remove("rock-hit"), 400);

      // tiny dust puff
      const puff = document.createElement("div");
      puff.className = "rock-impact";
      puff.style.left = `${endX}px`;
      puff.style.top  = `${endY}px`;
      container.appendChild(puff);
      setTimeout(() => {
        puff.remove();
        onComplete();
      }, 600);

      last.removeEventListener("animationend", handleImpact);
    };
    last.addEventListener("animationend", handleImpact);

    // cleanup if unmounted early
    return () => {
      rocks.forEach(r => r.remove());
      last.removeEventListener("animationend", handleImpact);
    };
  }, [opponentRef, onComplete]);

  return null;
}

RockThrowAnimation.moveType = "rock";
